import React from 'react';
import { NotificationContainer } from 'containers';

function NotificationPage() {
  return (
    <div className="d-flex w-100">
      <NotificationContainer key="NotificationContainerPage" isPage />
    </div>
  );
}

NotificationPage.propTypes = {};

export default NotificationPage;
